import Head from 'next/head';
import { shopPhoto, shopMapLinks, shopThemes, shopPageUrl } from '../../config/shops';

export default function ShopSeo({ shop, t, locale }) {
  const canonical = shopPageUrl(shop, locale);
  const title = t(`${shop.slug}.title`);
  const description = t(`${shop.slug}.description`);
  const photo = shop.photos[0];
  const image = `https://krit.ro${shopPhoto(shop, photo)}`;
  const imageAlt = t(`${shop.slug}.photos.${photo.file}`);
  const data = {
    '@context': 'https://schema.org', '@type': 'Store', '@id': `${shopPageUrl(shop)}#store`,
    name: `KRIT ${shop.city}`, url: shopPageUrl(shop), description,
    telephone: shop.telephone, email: shop.email,
    logo: 'https://krit.ro/icons/logo-vector.svg',
    image: shop.photos.map(photo => `https://krit.ro${shopPhoto(shop, photo)}`),
    address: { '@type': 'PostalAddress', streetAddress: shop.street, addressLocality: shop.city, addressRegion: shop.region, addressCountry: 'RO', ...(shop.postalCode ? { postalCode: shop.postalCode } : {}) },
    geo: { '@type': 'GeoCoordinates', latitude: shop.coordinates.lat, longitude: shop.coordinates.lon },
    hasMap: shopMapLinks(shop).map, sameAs: [shop.facebook],
    openingHoursSpecification: shop.hours.map(hours => ({
      '@type': 'OpeningHoursSpecification', dayOfWeek: hours.days,
      opens: hours.closed ? '00:00' : hours.opens, closes: hours.closed ? '00:00' : hours.closes,
    })),
  };
  return <Head>
    <title>{title}</title><meta name="description" content={description} />
    <meta name="robots" content="index, follow, max-image-preview:large" />
    <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" /><meta name="theme-color" content={shopThemes[shop.theme]['--shop-bg']} />
    <link rel="canonical" href={canonical} />
    <link rel="alternate" hrefLang="ro" href={shopPageUrl(shop)} /><link rel="alternate" hrefLang="en" href={shopPageUrl(shop, 'en')} />
    <link rel="alternate" hrefLang="x-default" href={shopPageUrl(shop)} />
    <meta property="og:title" content={title} /><meta property="og:description" content={description} />
    <meta property="og:url" content={canonical} /><meta property="og:type" content="website" /><meta property="og:site_name" content="KRIT" />
    <meta property="og:locale" content={locale === 'en' ? 'en_GB' : 'ro_RO'} />
    <meta property="og:locale:alternate" content={locale === 'en' ? 'ro_RO' : 'en_GB'} />
    <meta property="og:image" content={image} /><meta property="og:image:alt" content={imageAlt} />
    <meta property="og:image:width" content={String(photo.width)} /><meta property="og:image:height" content={String(photo.height)} />
    <meta property="og:image:type" content="image/webp" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} /><meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={image} /><meta name="twitter:image:alt" content={imageAlt} />
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data).replace(/</g, '\\u003c') }} />
  </Head>;
}
